import React from 'react';

import { i18n } from '../../../../../../../helpers/i18n';
import { Heading } from '../../../heading';
import { Island } from '../../../island';
import { NoiseCancellationTumbler } from '../sound-supported/noise-cancellation-tumbler';
import css from './styles.css';

export const AdditionalSoundSection = () => {
    return (
        <Island className={css.soundWrapper}>
            <div className={css.headingWrapper}>
                <Heading title={i18n('settings-v2', 'additional-settings-title')} />
            </div>

            <NoiseCancellationTumbler />
        </Island>
    );
};
